const RANKING_LOADING = "RANKING_LOADING";
const RANKING_SUCCESS = "RANKING_SUCCESS";
const RANKING_ERROR = "RANKING_ERROR";

export {
    RANKING_LOADING,
    RANKING_ERROR,
    RANKING_SUCCESS,
};